import cookieManager from '@s-ui/js/lib/cookie'

import AuthenticationValueObjectsFactory from '../ValueObjects/factory.js'
import ConfigRepository from './ConfigRepository.js'
import CookieAuthenticationRepository from './CookieAuthenticationRepository.js'
import {HttpAuthenticationRepository} from './HttpAuthenticationRepository.js'
import LegacyCookieAuthenticationRepository from './LegacyCookieAuthenticationRepository.js'
import ScreensetRepository from './ScreensetRepository.js'
import SessionStorageAuthenticationRepository from './SessionStorageAuthenticationRepository.js'

export default class AuthenticationRepositoriesFactory {
  static cookieAuthenticationRepository = ({config}) =>
    new CookieAuthenticationRepository({
      cookieManager,
      config
    })

  static legacyCookieAuthenticationRepository = ({config}) =>
    new LegacyCookieAuthenticationRepository({
      cookieManager,
      config
    })

  static httpAuthenticationRepository = ({config}) =>
    HttpAuthenticationRepository.create({
      config
    })

  static sessionStorageAuthenticationRepository = ({config}) => new SessionStorageAuthenticationRepository()

  static screensetRepository = ({config}) =>
    new ScreensetRepository({
      screensets: config.get('LOGIN_SCREENSET_ID_MAPPING'),
      screensetValueObjectsFactory: AuthenticationValueObjectsFactory.screensetValueObject
    })

  static configRepository = ({config}) =>
    new ConfigRepository({
      config
    })
}
